import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductMedals } from '@/features/medals'

export const Route = createFileRoute('/_event/medalhas')({
  component: DigitalProductMedalsPage
})

function DigitalProductMedalsPage() {
  return <DigitalProductMedals />
}
